import { render, staticRenderFns } from "./WhatsappButton.vue?vue&type=template&id=6f7f5eb4&"
import script from "./WhatsappButton.vue?vue&type=script&lang=ts&"
export * from "./WhatsappButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports